import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class CallingCodeConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getCallingCodesEndpoint(): string {
		return this.configService.get(
			(x) => x.core.callingCode.endpoints!.callingCodes,
			"i18n/v2/countries/calling-codes/"
		);
	}

	getIsSingleMarketCallingCodesEnabled(): boolean {
		return this.configService.get((x) => x.core.callingCode.isSingleMarketCallingCodesEnabled, false);
	}
}
